<template>
    <div class="quick-auth-overlay" @click.self="$emit('cancel')">
        <div class="quick-auth-modal">
            <div class="logo-section">
                <img src="/img/logo-2024-tb.png" alt="Logo" class="logo" />
            </div>
            <h2 class="title">確認登出</h2>
            <p class="subtitle">您確定要登出牧陽能控平台嗎？</p>

            <div class="button-group">
                <button
                    class="cancel-btn"
                    @click="$emit('cancel')"
                    :disabled="loading"
                >
                    取消
                </button>
                <button
                    class="logout-btn"
                    @click="handleLogout"
                    :disabled="loading"
                >
                    <span v-if="loading" class="loading-content">
                        <span class="spinner"></span>
                        登出中...
                    </span>
                    <span v-else>確認登出</span>
                </button>
            </div>

            <p v-if="error" class="error-message">{{ error }}</p>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import { supabase } from '@shared/services/core/supabaseClient';
import { eventBus } from '@shared/stores/globalState';

export default {
    name: 'QuickLogout',
    emits: ['cancel', 'logout'],
    setup(props, { emit }) {
        const loading = ref(false);
        const error = ref('');

        const handleLogout = async () => {
            loading.value = true;
            error.value = '';

            try {
                const { error: signOutError } = await supabase.auth.signOut();

                if (signOutError) {
                    throw signOutError;
                }

                // 通知系統用戶已登出
                eventBus.emit('user:logout');

                console.log('[QuickLogout] 登出成功');

                // 發送登出完成事件
                emit('logout');
            } catch (err) {
                console.error('[QuickLogout] 登出失敗:', err);
                error.value = '登出發生錯誤，請稍後再試';
            } finally {
                loading.value = false;
            }
        };

        return {
            loading,
            error,
            handleLogout
        };
    }
};
</script>

<style scoped lang="stylus">
.quick-auth-overlay
    position: fixed
    inset: 0
    background: rgba(0, 0, 0, 0.6)
    display: flex
    align-items: center
    justify-content: center
    z-index: 9999
    padding: 20px

.quick-auth-modal
    background: #fff
    border-radius: 16px
    padding: 40px
    width: 100%
    max-width: 400px
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3)
    text-align: center

.logo-section
    margin-bottom: 20px

    .logo
        width: 80px
        height: auto

.title
    font-size: 24px
    font-weight: bold
    color: #333
    margin-bottom: 8px

.subtitle
    font-size: 14px
    color: #666
    margin-bottom: 32px

.button-group
    display: flex
    gap: 12px

    button
        flex: 1
        padding: 14px 20px
        border-radius: 8px
        font-size: 16px
        font-weight: 500
        cursor: pointer
        transition: all 0.2s ease

        &:disabled
            opacity: 0.6
            cursor: not-allowed

.cancel-btn
    background: #fff
    border: 1px solid #ddd
    color: #666

    &:hover:not(:disabled)
        background: #f5f5f5
        border-color: #ccc

.logout-btn
    background: #0b3465
    border: 1px solid #0b3465
    color: #fff
    display: flex
    align-items: center
    justify-content: center

    &:hover:not(:disabled)
        background: #1a4a7a

.loading-content
    display: flex
    align-items: center
    gap: 8px

.spinner
    width: 18px
    height: 18px
    border: 2px solid rgba(255, 255, 255, 0.3)
    border-top-color: #fff
    border-radius: 50%
    animation: spin 1s linear infinite

@keyframes spin
    to
        transform: rotate(360deg)

.error-message
    margin-top: 16px
    padding: 12px
    background: #fff2f0
    border: 1px solid #ffccc7
    border-radius: 6px
    color: #ff4d4f
    font-size: 14px
</style>
